<template>
  <div class="box">
    <h3>{{ quiz.title }}</h3>
    <p v-html="quiz.description"></p>
    <button class="button is-success" @click="showQuiz" v-if="!switches.showQuiz && !switches.showResults">Take the Quiz</button>
    <template v-if="switches.showQuiz || showResultsDescription">
      <div class="field" v-for="(question, questionKey) in quiz.questions" :key="questionKey">
        <label class="label">{{ question.question }}</label>
        <div class="control" v-for="(answer, answerKey) in question.answers" :key="answerKey">
          <input type="radio" @input="saveAnswers" v-model="answers[questionKey]" :value="answerKey" :disabled="showResultsDescription">&nbsp;
          <span
            v-if="showResultsDescription"
            :class="{
            'has-text-danger': !isAnswerCorrect(question, answerKey),
            'has-text-success': isAnswerCorrect(question, answerKey),
            'has-text-weight-bold': isAnswerCorrect(question, answerKey)}">
            {{ answer }}
          </span>
          <span v-else>
            {{ answer }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * Copyright (c) 2019. Filip Conka <filip@conka.pro>
 */
import { mapGetters } from 'vuex'

export default {
  name: 'Quiz',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      answers: {},
      switches: {
        showQuiz: true,
        showResults: false
      }
    }
  },
  computed: {
    ...mapGetters('quizes', {
      quizStorage: 'getQuiz',
      answeredQuizStorage: 'getAnsweredQuiz'
    }),
    quiz () {
      return this.quizStorage(this.id)
    },
    answeredQuiz () {
      return this.answeredQuizStorage(this.id)
    },
    numberOfCorrectAnswers () {
      let correct = 0
      for (let key in this.quiz.questions) {
        if (this.quiz.questions[key] && this.quiz.questions[key].correct_answer === this.answers[key]) {
          correct++
        }
      }

      return correct
    },
    numberOfQuestion () {
      return this.quiz.questions.length
    },
    isAnswerCorrect () {
      return (question, answer) => {
        return question.correct_answer === answer
      }
    },
    showResultsDescription () {
      return Object.keys(this.answers).length === this.numberOfQuestion
    }
  },
  methods: {
    showQuiz () {
      this.switches.showQuiz = true
    },
    showResults () {
      this.switches.showQuiz = false
      this.switches.showResults = true
    },
    saveAnswers () {
      this.$nextTick(() => this.$store.dispatch('quizes/updateAnsweredQuiz', { id: this.quiz.id, answers: this.answers, numberOfCorrectAnswers: this.numberOfCorrectAnswers }))
    }
  },
  watch: {
    quiz () {
      this.answers = {}
    },
    answeredQuiz () {
      this.answers = (this.answeredQuiz === null) ? {} : this.answeredQuiz
    }
  }
}
</script>

<style scoped>

</style>
